module.exports = __webpack_public_path__ + "img/moshtari.942f29b6.png";